export const SET_WINDOW = 0;
export const IS_CARTOONS = 1;
